
import { Mixins, Component, Ref, Prop, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { Form } from "element-ui/types";
// TODO: 替换为实际的接口
// import { getAiEvaluationWeightDetail, updateAiEvaluationWeight } from "@/api/aiEvaluationWeight";

@Component({ name: 'ai-evaluation-weight-components-editDialog', components: {} })
export default class EditDialog extends Mixins(loading) {
  @Ref("validateForm") validateForm: Form;
  @Prop([Boolean]) private dialogVisible!: boolean;
  @Prop([Number]) private id!: number;

  formData = {
    tongueConstitution: "",
    bodyFatType: "",
    symptom: "",
    reason: "",
    preventDisease: "",
  };

  rules = {
    symptom: [
      { required: true, message: "请输入症状", trigger: "blur" },
    ],
    reason: [
      { required: true, message: "请输入原因", trigger: "blur" },
    ],
    preventDisease: [
      { required: true, message: "请输入预防疾病", trigger: "blur" },
    ],
  };

  dialogClose() {
    this.validateForm?.resetFields();
    this.$emit('closeEditDialog');
  }

  saveData() {
    this.validateForm?.validate().then((valid) => {
      if (valid) {
        const params = {
          ...this.formData
        }
        this.showLoading();
        // TODO: 替换为实际的编辑接口
        // updateAiEvaluationWeight(params).then((res) => {
        //     this.$message.success("保存成功");
        //     this.$emit('editDialogConfirm');
        // }).finally(() => {
        //     this.hideLoading();
        // })
        this.$message.success("保存成功");
        this.$emit('editDialogConfirm');
        this.hideLoading();
      }
    })
  }

  @Watch("dialogVisible", { immediate: true })
  getData() {
    if(this.dialogVisible != true) return;
    // TODO: 替换为实际的详情接口
    // getAiEvaluationWeightDetail({ id: this.id }).then((res) => {
    //   this.formData = res.data || {};
    // })
  }
}
